import { useEffect, useState } from "react";
import { Mail } from "lucide-react";
import { WhatsAppIcon } from "./WhatsAppIcon";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import { CONTACT, waHref } from "@/data/contact";

export const TAGLINES = [
  "From Coordinates to CAD Excellence.",
  "Precision in Surveying, Excellence in Drafting.",
  "Mapping Accuracy. Drafting Perfection.",
  "Transforming Survey Data into Precision Drawings.",
  "Your Coordinates, Our Expertise.",
  "Every Point. Every Line. Every Detail.",
  "Geospatial Accuracy, CAD Excellence.",
];

export const TopBar = ({ hidden }) => (
  <div className={`overflow-hidden border-b border-white/10 bg-[#0A1D30] transition-[height] duration-300 ${hidden ? "h-0 border-b-0" : "h-10"}`} data-testid="topbar">
    <div className="mx-auto flex h-10 max-w-[1400px] items-center justify-between gap-6 px-5 sm:px-8">
      <div className="flex shrink-0 items-center gap-5">
        <a href={`mailto:${CONTACT.email}`} data-testid="topbar-email-link"
          className="u-link inline-flex items-center gap-2 font-mono text-[11px] tracking-[0.14em] text-[#c3d0dd] hover:text-white">
          <Mail className="h-3.5 w-3.5 text-[#D8B66A]" />{CONTACT.email}
        </a>
        {CONTACT.whatsapp.map((n) => (
          <a key={n.region} href={waHref(n)} target="_blank" rel="noreferrer" data-testid={`topbar-whatsapp-${n.region.toLowerCase()}`}
            className="u-link hidden items-center gap-2 font-mono text-[11px] tracking-[0.14em] text-[#c3d0dd] hover:text-white md:inline-flex">
            <WhatsAppIcon className="h-3.5 w-3.5 text-[#25D366]" /><span className="text-[#9fb3c8]">{n.region}</span>{n.label}
          </a>
        ))}
      </div>
      <Tagline />
    </div>
  </div>
);

const Tagline = () => {
  const reduce = useReducedMotion();
  const [i, setI] = useState(0);
  useEffect(() => {
    if (reduce) return undefined;
    const id = setInterval(() => setI((n) => (n + 1) % TAGLINES.length), 4000);
    return () => clearInterval(id);
  }, [reduce]);
  const label = TAGLINES[reduce ? 0 : i];
  return (
    <p className="relative hidden h-4 min-w-0 flex-1 overflow-hidden text-right font-mono text-[11px] uppercase tracking-[0.18em] text-[#9fb3c8] sm:block" aria-live="off" data-testid="topbar-tagline">
      <AnimatePresence mode="wait">
        <motion.span key={label} initial={{ y: 14, opacity: 0 }} animate={{ y: 0, opacity: 1 }} exit={{ y: -14, opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.7, 0, 0.2, 1] }} className="absolute right-0 whitespace-nowrap">
          {label}
        </motion.span>
      </AnimatePresence>
      <span className="sr-only">{TAGLINES[0]}</span>
    </p>
  );
};
